import { API_TYPE } from '@umu/umu-fetch';
import { FILE_API_TYPE } from "../interface";

const PRE_URL = '/napi/v1';
const FILE_BASE_URI = '/excel-file';

export const FILE_PROCESS_API_OPTION = {
	[FILE_API_TYPE.DOWNLOAD_EXCEL]: {
		url: `${PRE_URL}${FILE_BASE_URI}/download-excel`,
		type: API_TYPE.POST,
	},
	[FILE_API_TYPE.UPLOAD]: {
		url: `${PRE_URL}${FILE_BASE_URI}/upload`,
		type: API_TYPE.POST,
	},
	[FILE_API_TYPE.PROGRESS]: {
		url: `${PRE_URL}${FILE_BASE_URI}/progress`,
		type: API_TYPE.GET,
	},
	[FILE_API_TYPE.EXPORT]: {
		url: `${PRE_URL}${FILE_BASE_URI}/export-data-list`,
		type: API_TYPE.POST,
	},
	[FILE_API_TYPE.DOWNLOAD_FAILED_RECORDS]: {
		url: `${PRE_URL}${FILE_BASE_URI}/download-failed-records`,
		type: API_TYPE.POST,
	},
};
